import clsx from 'clsx'
import PropTypes from 'prop-types'

import Typo from './typo'

const Textarea = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  rows = 4,
  className = ''
}) => {
  return (
    <div className={clsx('w-full', className)}>
      {label && (
        <>
          <Typo type='t1bold'>{label}</Typo>
          <div className='mb-2' />
        </>
      )}
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        className='w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
      />
    </div>
  )
}

Textarea.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string
}

export default Textarea
